/* eslint-disable */
// eslint-disable
import React, { useState, useEffect, useRef } from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import footballLogo from "../../../assets/images2/logo-football.png";
import pageantLogo from "../../../assets/images2/logo-pageant.png";
import {
  BEAUTY_PAGEANT_LABEL,
  PAGEANT_SECTION_NAME,
} from "../../../utils/homeFlow";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import FreeVoteIcons from "../../../assets/customerAssets/freeVotesIcon.svg";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { useSelector } from "react-redux";
import userD from "../../../assets/customerAssets/user_D.jpeg";
import Skeleton from "react-loading-skeleton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import Fade from "@mui/material/Fade";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { Drawer } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { InputAdornment } from "@mui/material";
import GuestUserRistModal from "../../Modals/user/guestUserModalRist/Modal"
import {
  getHomeFlow,
  switchToOtherSection,
} from "../../../utils/homeFlow";
import SectionSwitchButton from "./SectionSwitchButton";

const login_register_btn_style = {
  borderRadius: "25px",
  padding: { xs: "5px 10px", md: "10px 20px" },
  cursor: "pointer",
  fontFamily: "Arial",
  fontStyle: "normal",
  fontWeight: "700",
  fontSize: { xs: "12px", sm: "14px", md: "16px" },
  lineHeight: { xs: "16px", md: "25px" },
  textAlign: "center",
  backgroundColor: "#ef364e",
  color: "white",
  "&:hover": {
    backgroundColor: "#871c2a",
    color: "white",
  },
  textTransform: "none",
};

const headerDesktopSideSx = {
  flex: 1,
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  minWidth: 0,
};

const headerDesktopCenterNavSx = {
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  flexShrink: 0,
};

const goalsIcon = (active, data) => {
  return (
    <svg
      width={data?.width || "28"}
      height={data?.height || "28"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.266 0.400024C10.6588 0.400024 7.19946 1.83333 4.64946 4.38346C2.09946 6.9336 0.666016 10.393 0.666016 14C0.666016 17.607 2.09932 21.0666 4.64946 23.6166C7.19959 26.1666 10.659 27.6 14.266 27.6C17.873 27.6 21.3326 26.1667 23.8826 23.6166C26.4326 21.0665 27.866 17.607 27.866 14C27.8618 10.3938 26.4274 6.93754 23.8785 4.38754C21.3285 1.83861 17.8722 0.404104 14.266 0.400024ZM24.1377 19.8831L19.842 19.8948L18.5001 18.0471L20.0694 13.2137L22.239 12.5082L25.7209 15.0465C25.5636 16.7571 25.0228 18.4105 24.1377 19.8831ZM2.81128 15.0467L6.29098 12.5052L8.46061 13.2107L10.0299 18.0441L8.6901 19.895L4.3944 19.8833C3.50934 18.4107 2.96852 16.7573 2.81128 15.0467ZM4.87785 10.9466L2.88143 12.4075C3.06524 11.0719 3.48385 9.7778 4.11819 8.5878L4.87785 10.9466ZM11.952 17.1813L10.5208 12.7836L14.2663 10.0626L18.0117 12.7826L16.5805 17.1846L11.952 17.1813ZM23.6543 10.9466L24.414 8.5878C25.0472 9.7778 25.4648 11.0719 25.6486 12.4075L23.6543 10.9466ZM22.9127 6.42673L21.5941 10.5141L19.4234 11.2206L15.3126 8.23708V5.95484L18.8051 3.43353C20.3808 4.11459 21.7833 5.13884 22.9129 6.43097L22.9127 6.42673ZM16.272 2.6783L14.266 4.1286L12.26 2.6783C13.586 2.43073 14.946 2.43073 16.272 2.6783ZM9.72718 3.43372L13.2197 5.95503V8.23727L9.10892 11.2249L6.94356 10.5183L5.61968 6.431C6.74911 5.139 8.15162 4.11476 9.72742 3.43356L9.72718 3.43372ZM5.99343 21.9809L8.4648 21.9872L9.23404 24.3332H9.23298C8.02492 23.7435 6.92838 22.9477 5.99343 21.9809ZM11.7234 25.2152L10.3846 21.1246L11.7255 19.278H16.8076L18.1484 21.1246L16.8097 25.2152C15.1363 25.6062 13.3958 25.6062 11.7225 25.2152H11.7234ZM19.2999 24.3333L20.0692 21.9873L22.5406 21.981H22.5384C21.6034 22.9478 20.5069 23.7437 19.2989 24.3333L19.2999 24.3333Z"
        fill={active ? "#d93349" : "#757686"}
      />
    </svg>
  );
};

const leaderboardIcon = (active, data) => {
  return (
    <svg
      width={data?.width || "31"}
      height={data?.height || "26"}
      viewBox="0 0 31 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.54619 20.2198H21.9942C22.0291 20.2198 22.064 20.2211 22.0975 20.2223L25.604 11.1214L20.2026 13.7709V13.7697C19.8578 13.9383 19.438 13.8042 19.2597 13.4656L15.2702 5.94752L11.2985 13.4326C11.1099 13.8082 10.6914 13.9449 10.3375 13.7711L4.93478 11.1216L8.44128 20.2225C8.47615 20.2213 8.51102 20.22 8.5459 20.22L8.54619 20.2198ZM27.8308 6.99477C26.5508 6.99477 26.5508 8.91743 27.8308 8.91743C29.1107 8.91743 29.1107 6.99477 27.8308 6.99477ZM26.1362 6.28064C27.6435 4.78978 30.2266 5.85267 30.2266 7.95674C30.2266 9.41951 28.9002 10.5309 27.4433 10.2959L23.4484 20.6655C25.5576 22.0937 24.4985 25.3334 21.9928 25.3334H8.54609C6.28841 25.3334 5.07431 22.602 6.72109 20.9706L6.7198 20.9693C6.83346 20.8569 6.95745 20.7547 7.09049 20.6653L3.0943 10.2957C0.812083 10.6636 -0.629434 7.90415 1.01226 6.28054C2.51954 4.78968 5.10268 5.85257 5.10268 7.95665C5.10268 8.49702 4.91927 8.99527 4.61187 9.39384L10.3453 12.2057L14.2201 4.90342C11.9469 3.80858 12.7386 0.400024 15.2689 0.400024C17.3897 0.400024 18.4746 2.94741 16.9622 4.44458L16.9634 4.44586C16.7762 4.6311 16.5579 4.78569 16.3177 4.90192L20.1925 12.2042L25.9259 9.39234C25.1975 8.45081 25.2891 7.11964 26.1364 6.28032L26.1362 6.28064ZM15.9573 2.09153C15.0519 1.19598 13.6776 2.55655 14.5831 3.45079C14.9628 3.82637 15.5789 3.82637 15.9573 3.45079L15.9586 3.45207C16.3409 3.04964 16.3331 2.46331 15.9573 2.09153ZM3.39539 7.27682C2.48869 6.38 1.11575 7.74312 2.02116 8.63866C2.92141 9.53038 4.30209 8.17364 3.39539 7.27682ZM21.9942 21.6285H8.54619C8.22717 21.6285 7.93787 21.7575 7.72731 21.9658L7.72602 21.9645C6.97175 22.7578 7.56716 23.9242 8.54619 23.9242H21.9942C23.5015 23.9255 23.5325 21.6285 21.9942 21.6285Z"
        fill={active ? "#d93349" : "#757686"}
        stroke={active ? "#d93349" : "#757686"}
        stroke-width="0.623333"
      />
    </svg>
  );
};

const myAccountIcon = (active, data) => {
  return (
    <svg
      width={data?.width || "24"}
      height={data?.height || "28"}
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9435 12.9285C17.6828 11.6685 18.8154 9.62935 18.8154 7.33213C18.8154 3.51474 15.6888 0.409058 11.8457 0.409058C8.0026 0.409058 4.876 3.51474 4.876 7.33213C4.876 9.62935 6.00856 11.6685 7.74788 12.9285C3.42426 14.5719 0.345703 18.7359 0.345703 23.6014C0.345703 25.7009 2.06533 27.4091 4.17904 27.4091H19.5124C21.6261 27.4091 23.3457 25.7009 23.3457 23.6014C23.3457 18.7359 20.2671 14.5719 15.9435 12.9285ZM6.96693 7.33213C6.96693 4.65998 9.15555 2.486 11.8457 2.486C14.5359 2.486 16.7245 4.65998 16.7245 7.33213C16.7245 10.0043 14.5359 12.1783 11.8457 12.1783C9.15555 12.1783 6.96693 10.0043 6.96693 7.33213ZM19.5124 25.3321H4.17904C3.21827 25.3321 2.43664 24.5557 2.43664 23.6013C2.43664 18.4478 6.65747 14.2552 11.8458 14.2552C17.034 14.2552 21.2549 18.4477 21.2549 23.6013C21.2548 24.5557 20.4732 25.3321 19.5124 25.3321Z"
        fill={active ? "#d93349" : "#757686"}
      />
    </svg>
  );
};

const settingsIcon = (active, data) => {
  return (
    <svg
      width={data?.width || "26"}
      height={data?.height || "28"}
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.29653 8.23022L2.45865 6.17976C3.2761 4.73775 5.06296 4.20665 6.50732 4.97213C7.10595 5.28962 7.71707 5.26192 8.29983 4.91786C8.86897 4.58305 9.20232 4.04504 9.23178 3.37308C9.30434 1.71516 10.657 0.400024 12.2782 0.400024H14.6036C16.2249 0.400024 17.5786 1.71504 17.65 3.37308C17.6795 4.04965 18.0151 4.58305 18.5945 4.92478C19.1704 5.2642 19.7861 5.28383 20.3756 4.97096C21.8189 4.20667 23.6058 4.73543 24.4231 6.17399L25.5853 8.22445C26.4027 9.66646 25.9583 11.5034 24.5819 12.3957C24.0229 12.7582 23.7315 13.3321 23.7315 14.0063C23.7315 14.6771 24.0274 15.2428 24.583 15.603C25.9572 16.4954 26.4027 18.3289 25.5853 19.7698L24.4231 21.8203C23.6057 23.2623 21.8188 23.7922 20.3745 23.0279C19.7758 22.7116 19.1647 22.7393 18.582 23.0822C18.0128 23.417 17.6795 23.955 17.65 24.627C17.5774 26.2849 16.2248 27.6 14.6036 27.6H12.2782C10.6535 27.6 9.30431 26.2931 9.23175 24.627C9.20228 23.9492 8.86668 23.417 8.28732 23.0753C7.71248 22.7358 7.09571 22.7174 6.50615 23.0291C5.06284 23.7934 3.27599 23.2658 2.45749 21.8261L1.29537 19.7756C0.479047 18.3382 0.922342 16.4966 2.29875 15.6043C2.85771 15.2418 3.14909 14.668 3.14909 13.9938C3.14909 13.323 2.85318 12.7573 2.29875 12.3971C0.924606 11.5046 0.479076 9.67117 1.29653 8.23022ZM13.4416 8.51655C10.4678 8.51655 8.05611 10.9723 8.05611 14.0007C8.05611 17.0291 10.4677 19.4848 13.4416 19.4848C16.4156 19.4848 18.8284 17.0291 18.8284 14.0007C18.8284 10.9723 16.4168 8.51655 13.4416 8.51655ZM15.631 11.7713C14.4224 10.5405 12.4609 10.5405 11.2523 11.7713C10.0437 13.002 10.0437 14.9994 11.2523 16.2301C12.4609 17.4609 14.4224 17.4609 15.631 16.2301C16.8396 14.9994 16.8396 13.002 15.631 11.7713ZM4.43614 7.33667L3.27401 9.38713C3.06994 9.74736 3.17651 10.2138 3.52458 10.4389C4.73886 11.2275 5.43159 12.5263 5.43046 13.9936C5.42933 15.4772 4.75134 16.7668 3.52458 17.5622C3.17878 17.7862 3.06767 18.248 3.27288 18.6106L4.43274 20.6622C4.64702 21.0293 5.08353 21.1575 5.45087 20.9624C6.7207 20.2904 8.19121 20.3308 9.43161 21.064C10.6844 21.804 11.4486 23.0509 11.5121 24.5288C11.5302 24.941 11.859 25.2712 12.2785 25.2712H14.6039C15.0245 25.2712 15.3511 24.9502 15.3692 24.53C15.4327 23.0683 16.1912 21.8053 17.4372 21.0722C18.6866 20.3356 20.1504 20.2859 21.4305 20.9637C21.7989 21.1588 22.2434 21.026 22.4474 20.667L23.6096 18.6165C23.8136 18.2563 23.7071 17.7898 23.359 17.5647C22.1447 16.7773 21.452 15.4773 21.4531 14.01C21.4543 12.5264 22.1322 11.238 23.359 10.4414C23.7059 10.2162 23.8148 9.75444 23.6107 9.39305L22.4497 7.34144C22.2377 6.97429 21.7989 6.84614 21.4316 7.04127C20.1618 7.7132 18.6912 7.67164 17.4508 6.93967C16.198 6.20076 15.4338 4.9527 15.3703 3.4748C15.3522 3.05339 15.0257 2.73359 14.605 2.73359H12.2797C11.859 2.73359 11.5325 3.05454 11.5144 3.4748C11.4509 4.93644 10.6924 6.19952 9.44636 6.93258C8.19693 7.66917 6.73321 7.71883 5.45314 7.0411C5.08467 6.84598 4.64021 6.97876 4.43614 7.33782V7.33667Z"
        fill={active ? "#d93349" : "#757686"}
      />
    </svg>
  );
};

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "20px",
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  border: "1px solid #414466",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  color: "#414466",
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "#2e3152",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
  },
}));

const StyledInputBaseMobile = styled(InputBase)(({ theme }) => ({
  color: "#2e3152",
  border: "1px solid #414466",
  borderRadius: "25px",
  padding: "5px",
  "& .MuiInputBase-input": {
    padding: "0",
  },
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: "-10px",
    padding: "0 3px",
    backgroundColor: "#d93349",
    color: "white",
  },
}));

const settings = ["Logout"];

export default function PrimarySearchAppBar({
  hideMainNav = false,
  showChangeSection = false,
}) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { logout } = useAuth();
  const searchRef = useRef();
  const searchButtonRef = useRef();
  const [gSearch, setGSearch] = useState(false);
  const globalSearch = useSelector((state) => state.globalSearch);
  const [globalSearchState, setGlobalSearchState] = useState("");
  const searchInput = useRef(null);
  const urlparam = useParams();
  const { pathname: currentPath = "" } = useLocation();
  const location = currentPath.split("/")[1];
  const notifications = useSelector((state) => state.notifications.data);
  const userVote = useSelector((state) => state.userVote);
  const headerVotes = Number(userVote.count || 0);
  const loggedUser = useSelector((state) => state.loggedUser.user);
  const [openGuestRistModal, setOpenGuestRistModal] = React.useState(false);

  const flow = getHomeFlow();
  const onPageantRoute = location === "competitions";
  const onFashionRoute = location === "fashion-designers";
  const isPageantSection = flow === "pageant" || onPageantRoute || onFashionRoute;
  const headerLogo = isPageantSection ? pageantLogo : footballLogo;
  const shouldHideMainNav = Boolean(hideMainNav) || onPageantRoute || onFashionRoute;
  const shouldShowChangeSection =
    Boolean(showChangeSection) ||
    onPageantRoute ||
    onFashionRoute ||
    flow === "existing" ||
    flow === "pageant";

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const [drawer, setDrawer] = useState(false);

  const [unReadCount, setunReadCount] = useState(0);

  useEffect(() => {
    if (notifications.length > 0) {
      setunReadCount(notifications.filter((data) => !data.is_read).length);
    }
  }, [notifications]);

  const handleGlobalSearchChange = (e) => {
    e.preventDefault();
    setGlobalSearchState(e.target.value);
    dispatch({
      type: "SEARCH",
      payload: {
        search: e.target.value,
        api:
          window.location.pathname.split("/")[1] == ""
            ? "home"
            : window.location.pathname.split("/")[1],
      },
    });
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSwitchSection = () => {
    setAnchorElUser(null);
    setDrawer(false);
    switchToOtherSection({ isPageantSection, navigate });
  };

  const renderSectionSwitchButton = (opts = {}) =>
    shouldShowChangeSection ? (
      <SectionSwitchButton
        isPageantSection={isPageantSection}
        onClick={handleSwitchSection}
        {...opts}
      />
    ) : null;

  const renderLogoColumn = () => (
    <Box
      sx={{
        flex: { xs: 0, md: 1 },
        display: "flex",
        alignItems: "center",
        minWidth: 0,
      }}
    >
      <Box className="main-logo-div" aria-label="open drawer">
        <img
          src={headerLogo}
          alt={
            isPageantSection
              ? `MyNetGoals ${BEAUTY_PAGEANT_LABEL}`
              : "MyNetGoals"
          }
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
          }}
          onClick={() => {
            navigate("/");
          }}
        />
      </Box>
    </Box>
  );

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={17} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      {user.loading ? (
        <Skeleton height={100} style={{}} />
      ) : !user?.data ? ( /////////////////////////////  for guest users
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" className="user-app-bar" sx={{ backgroundColor: "white" }}>
            <Toolbar sx={{ width: "100%", gap: { md: 1 } }}>
              {renderLogoColumn()}

              {gSearch ? (
                <>
                  <Fade in={gSearch} timeout={500}>
                    <Box
                      sx={{
                        ...headerDesktopSideSx,
                        justifyContent: "center",
                      }}
                    >
                      <Search ref={searchRef}>
                        <SearchIconWrapper>
                          <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                          placeholder="Search…"
                          inputProps={{ "aria-label": "search" }}
                          name="globalSearch"
                          value={globalSearch.search}
                          onChange={handleGlobalSearchChange}
                          ref={searchInput}
                        />
                      </Search>
                    </Box>
                  </Fade>
                </>
              ) : shouldHideMainNav ? null : (
                <Box sx={headerDesktopCenterNavSx}>
                  <Button
                    onClick={() => {
                      navigate("/");
                    }}
                    sx={
                      location == ""
                        ? { my: 2, color: "#d93349" }
                        : { my: 2, color: "#757686" }
                    }
                    className="appBar-btn"
                  >
                    {goalsIcon(location == "" ? true : false)}
                    Goal Stream
                  </Button>

                  <Button
                    onClick={() => {
                       if(loggedUser.device_id){
        setOpenGuestRistModal(true);
        return ;
      }
                    }}
                    sx={{ my: 2, color: "#757686" }}
                  >
                    <Box className="Add-icon-wrapper">
                      <Box className="Add-icon">+</Box>
                    </Box>
                  </Button>
                  <Button
                    onClick={() => {
                      navigate("/leaderboards");
                    }}
                    sx={
                      location == "leaderboards"
                        ? { my: 2, color: "#d93349" }
                        : { my: 2, color: "#757686" }
                    }
                    className="appBar-btn"
                  >
                    {leaderboardIcon(location == "leaderboards" ? true : false)}
                    Leaderboards
                  </Button>
                </Box>
              )}
              {/* ///////////////  desktop view for guest users */}
              <Box
                sx={{
                  ...headerDesktopSideSx,
                  justifyContent: "flex-end",
                  gap: "12px",
                }}
              >
                {renderSectionSwitchButton({ size: "small" })}
                <Tooltip title="Search">
                  <Button
                    sx={{
                      my: 2,
                      color: "#757686",
                      opacity:
                        location == "settings" ||
                        location == "addGoal" ||
                        location == "addTournament" ||
                        location == "addChallenge" ||
                        location == "notifications"
                          ? "0"
                          : "1",
                    }}
                    className="icon-btn"
                    onClick={() => {
                      if (gSearch) {
                        if (globalSearchState !== "") {
                          dispatch({
                            type: "EMPTY_GLOBAL_SEARCH",
                            payload:
                              window.location.pathname.split("/")[1] == ""
                                ? "home"
                                : window.location.pathname.split("/")[1],
                          });
                          setGlobalSearchState("");
                          setGSearch(false);
                        } else {
                          setGSearch(false);
                        }
                      } else {
                        setGSearch(true);
                        searchInput.current && searchInput.current.focus();
                      }
                    }}
                    ref={searchButtonRef}
                  >
                    {gSearch ? <CloseIcon /> : <SearchIcon />}
                  </Button>
                </Tooltip>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "3px",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    {/* <Tooltip title="Login"> */}
                    <Button
                      onClick={() => navigate("/login")}
                      sx={{
                        ...login_register_btn_style,
                      }}
                    >
                      Login
                    </Button>
                    {/* </Tooltip> */}
                  </Box>

                  {/* <Box
                    sx={{
                      border: "1px solid #191b2f",
                      height: { lg: "45px", md: "45px", sm: "31px", xs: "0px" },
                      display: { md: "block", sm: "block", xs: "none" },
                      transform: "rotate(5deg)",

                      // transform: "rotate(13deg)",
                      // display: { xs: "none", md: "block" },
                    }}
                  ></Box> */}

                  <Box>
                    {/* <Tooltip title="Register"> */}
                    <Button
                      onClick={() => navigate("/register")}
                      sx={{
                        ...login_register_btn_style,
                      }}
                    >
                      Register
                    </Button>
                    {/* </Tooltip> */}
                  </Box>
                </Box>
              </Box>
              {/* //////////////////////////////// mobile view for guest users  */}
              <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }} />
              <Box
                sx={{
                  flexGrow: 1,
                  display: { xs: "flex", md: "none" },
                  justifyContent: "end",
                  alignItems: "center",
                  paddingLeft: "8px",
                  gap: "8px",
                }}
                className="appBar-side-settings"
              >
                {renderSectionSwitchButton({ size: "small" })}
                {gSearch ? (
                  <>
                    <Fade in={gSearch} timeout={500}>
                      <StyledInputBaseMobile
                        placeholder="Search…"
                        inputProps={{ "aria-label": "search" }}
                        name="globalSearch"
                        value={globalSearch.search}
                        onChange={handleGlobalSearchChange}
                        ref={searchInput}
                        startAdornment={
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                      {/* </Search> */}
                    </Fade>
                  </>
                ) : null}

                <Tooltip title="Search">
                  <Button
                    sx={{
                      my: 2,
                      color: "#757686",
                      display:
                        location == "settings" ||
                        location == "addGoal" ||
                        location == "addTournament" ||
                        location == "addChallenge" ||
                        location == "notifications"
                          ? "none"
                          : "block",
                      minWidth: "0 !important",
                    }}
                    className="icon-btn"
                    onClick={() => {
                      if (gSearch) {
                        if (globalSearchState !== "") {
                          dispatch({
                            type: "EMPTY_GLOBAL_SEARCH",
                            payload:
                              window.location.pathname.split("/")[1] == ""
                                ? "home"
                                : window.location.pathname.split("/")[1],
                          });
                          setGlobalSearchState("");
                          setGSearch(false);
                        } else {
                          setGSearch(false);
                        }
                      } else {
                        setGSearch(true);
                        searchInput.current && searchInput.current.focus();
                      }
                    }}
                    ref={searchButtonRef}
                  >
                    {gSearch ? <CloseIcon /> : <SearchIcon />}
                  </Button>
                </Tooltip>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "3px",
                    alignItems: "center",
                    flexDirection: {
                      lg: "row",
                      sm: "row",
                      md: "row",
                      xs: "column",
                    },
                  }}
                >
                  <Box>
                    {/* <Tooltip title="Login"> */}
                    <Button
                      onClick={() => navigate("/login")}
                      sx={{
                        ...login_register_btn_style,
                      }}
                    >
                      Login
                    </Button>
                    {/* </Tooltip> */}
                  </Box>
                

                  <Box>
                    {/* <Tooltip title="Register"> */}
                    <Button
                      onClick={() => navigate("/register")}
                      sx={{
                        ...login_register_btn_style,
                      }}
                    >
                      Register
                    </Button>
                    {/* </Tooltip> */}
                  </Box>
                </Box>

                {/* //////////////////////////////////////  menue  */}
                <IconButton onClick={() => setDrawer(true)} color="black">
                  <MenuIcon />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
        </Box>
      ) : (
        //////////////////////////////////////  for logged in users
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" className="user-app-bar" sx={{ backgroundColor: "white", left: "0" }}>
            <Toolbar sx={{ width: "100%", gap: { md: 1 } }}>
              {renderLogoColumn()}

              {/* ///////////////////////////////////////////////////for desktop view  */}

              {gSearch ? (
                <>
                  <Fade in={gSearch} timeout={500}>
                    <Box
                      sx={{
                        ...headerDesktopSideSx,
                        justifyContent: "center",
                      }}
                    >
                      <Search ref={searchRef}>
                        <SearchIconWrapper>
                          <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                          placeholder="Search…"
                          inputProps={{ "aria-label": "search" }}
                          name="globalSearch"
                          value={globalSearch.search}
                          onChange={handleGlobalSearchChange}
                          ref={searchInput}
                        />
                      </Search>
                    </Box>
                  </Fade>
                </>
              ) : !shouldHideMainNav ? (
                <Box sx={headerDesktopCenterNavSx}>

                    {/* /////////// goal stream button  */}
                    <Button
                      onClick={() => {
                        navigate("/");
                      }}
                      sx={
                        location == ""
                          ? { my: 2, color: "#d93349" }
                          : { my: 2, color: "#757686" }
                      }
                      className="appBar-btn"
                    >
                      {goalsIcon(location == "" ? true : false)}
                      Goal Stream
                    </Button>

                    {/* //////////////////// leaderboard button  */}
                    <Button
                      onClick={() => {
                        navigate("/leaderboards");
                      }}
                      sx={
                        location == "leaderboards"
                          ? { my: 2, color: "#d93349" }
                          : { my: 2, color: "#757686" }
                      }
                      className="appBar-btn"
                    >
                      {leaderboardIcon(
                        location == "leaderboards" ? true : false
                      )}
                      Leaderboards
                    </Button>

                    {/* //////////////////// add goal button  */}
                    <Button
                      onClick={() => {
                        navigate("/addGoal");
                        setAnchorElNav(null);
                      }}
                      sx={{ my: 2, color: "#757686" }}
                    >
                      <Box className="Add-icon-wrapper">
                        <Box className="Add-icon">+</Box>
                      </Box>
                    </Button>

                    {/* //////////////////////////// my Account button  */}
                    <Button
                      onClick={() => {
                        navigate("/myaccount");
                      }}
                      sx={
                        location == "myaccount"
                          ? { my: 2, color: "#d93349" }
                          : { my: 2, color: "#757686" }
                      }
                      className="appBar-btn"
                    >
                      {myAccountIcon(location == "myaccount" ? true : false)}
                      My Account
                    </Button>

                    {/* /////////////////////////////////// settings button  */}
                    <Button
                      onClick={() => {
                        navigate("/settings/edit-profile");
                      }}
                      sx={
                        location == "settings"
                          ? { my: 2, color: "#d93349" }
                          : { my: 2, color: "#757686" }
                      }
                      className="appBar-btn"
                    >
                      {settingsIcon(location == "settings" ? true : false)}
                      Settings
                    </Button>
                  </Box>
              ) : null}

              {/* //////////////////////////////// for search icon  */}
              <Box
                sx={{
                  ...headerDesktopSideSx,
                  justifyContent: "flex-end",
                  gap: "12px",
                }}
                className="appBar-side-settings"
              >
                {renderSectionSwitchButton({ size: "small" })}
                <Tooltip title="Search">
                  <Button
                    sx={{
                      my: 2,
                      color: "#757686",
                      opacity:
                        location == "settings" ||
                        location == "addGoal" ||
                        location == "addTournament" ||
                        location == "addChallenge" ||
                        location == "notifications"
                          ? "0"
                          : "1",
                    }}
                    className="icon-btn"
                    onClick={() => {
                      if (gSearch) {
                        if (globalSearchState !== "") {
                          dispatch({
                            type: "EMPTY_GLOBAL_SEARCH",
                            payload:
                              window.location.pathname.split("/")[1] == ""
                                ? "home"
                                : window.location.pathname.split("/")[1],
                          });
                          setGlobalSearchState("");
                          setGSearch(false);
                        } else {
                          setGSearch(false);
                        }
                      } else {
                        setGSearch(true);
                        searchInput.current && searchInput.current.focus();
                      }
                    }}
                    ref={searchButtonRef}
                  >
                    {gSearch ? <CloseIcon /> : <SearchIcon />}
                  </Button>
                </Tooltip>

                {/* /////////////////////////  user votes icon  */}
                <Tooltip title="Votes">
                  <Button
                    sx={{ my: 2, color: "#757686" }}
                    className="free-vote-btn"
                  >
                    <img src={FreeVoteIcons} height={20} width={20} />
                    {/* {user?.data?.userVotes} */}
                    {headerVotes}
                  </Button>
                </Tooltip>

                {/* ///////////////////////////  notification button  */}
                <Tooltip title="Notifications">
                  <IconButton
                    sx={{ my: 2, color: "#757686" }}
                    className="icon-btn"
                    onClick={() => {
                      navigate("/notifications");
                    }}
                  >
                    <StyledBadge badgeContent={unReadCount}>
                      <NotificationsNoneIcon />
                    </StyledBadge>
                  </IconButton>
                </Tooltip>

                {/* /////////////////// user setting logout  */}
                <Tooltip title="Account">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                      alt="Remy Sharp"
                      src={
                        user.data?.profile_img ? user.data.profile_img : userD
                      }
                      sx={{ width: 58, height: 58 }}
                    />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {settings.map((setting) => (
                    <MenuItem
                      key={setting}
                      onClick={() => {
                        logout();
                        setAnchorElUser(null);
                      }}
                    >
                      <Typography sx={{ textAlign: "center" }}>
                        {setting}
                      </Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>

              {/* ///////////////////////////////////////////////////for desktop view  */}

              {/* for//////////////////////////////////////////////////////// mobile view  */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: { xs: "flex", md: "none" },
                  justifyContent: "end",
                  alignItems: "center",
                  paddingLeft: "8px",
                  gap: "8px",
                }}
                className="appBar-side-settings"
              >
                {renderSectionSwitchButton({ size: "small" })}
                {gSearch ? (
                  <>
                    <Fade in={gSearch} timeout={500}>
                      <StyledInputBaseMobile
                        placeholder="Search…"
                        inputProps={{ "aria-label": "search" }}
                        name="globalSearch"
                        value={globalSearch.search}
                        onChange={handleGlobalSearchChange}
                        ref={searchInput}
                        startAdornment={
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        }
                      />
                      {/* </Search> */}
                    </Fade>
                  </>
                ) : (
                  <>
                    {/* /////////////////////////  user votes icon  */}
                    <Tooltip title="Votes">
                      <Button
                        sx={{ my: 2, color: "#757686" }}
                        className="free-vote-btn"
                      >
                        <img src={FreeVoteIcons} height={20} width={20} />
                        {/* {user?.data?.userVotes} */}
                        {headerVotes}
                      </Button>
                    </Tooltip>

                    {/* ///////////////////////////  notification button  */}
                    <Tooltip title="Notifications">
                      <IconButton
                        sx={{ my: 2, color: "#757686" }}
                        className="icon-btn"
                        onClick={() => {
                          navigate("/notifications");
                        }}
                      >
                        <StyledBadge badgeContent={unReadCount}>
                          <NotificationsNoneIcon />
                        </StyledBadge>
                      </IconButton>
                    </Tooltip>
                  </>
                )}

                <Tooltip title="Search">
                  <Button
                    sx={{
                      my: 2,
                      color: "#757686",
                      display:
                        location == "settings" ||
                        location == "addGoal" ||
                        location == "addTournament" ||
                        location == "addChallenge" ||
                        location == "notifications"
                          ? "none"
                          : "block",
                      minWidth: "0 !important",
                    }}
                    className="icon-btn"
                    onClick={() => {
                      if (gSearch) {
                        if (globalSearchState !== "") {
                          dispatch({
                            type: "EMPTY_GLOBAL_SEARCH",
                            payload:
                              window.location.pathname.split("/")[1] == ""
                                ? "home"
                                : window.location.pathname.split("/")[1],
                          });
                          setGlobalSearchState("");
                          setGSearch(false);
                        } else {
                          setGSearch(false);
                        }
                      } else {
                        setGSearch(true);
                        searchInput.current && searchInput.current.focus();
                      }
                    }}
                    ref={searchButtonRef}
                  >
                    {gSearch ? <CloseIcon /> : <SearchIcon />}
                  </Button>
                </Tooltip>

                {/* //////////////////////////////////////  menue  */}
                <IconButton onClick={() => setDrawer(true)} color="black">
                  <MenuIcon />
                </IconButton>
              </Box>

              {/* for//////////////////////////////////////////////////////// mobile view  */}
            </Toolbar>
          </AppBar>
        </Box>
      )}

      <Drawer open={drawer} onClose={() => setDrawer(false)} anchor="right">
        {shouldHideMainNav ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 16px",
              gap: "12px",
              minWidth: 220,
            }}
          >
            {renderSectionSwitchButton({ fullWidth: true, size: "small" })}
            {loggedUser?.device_id || !user?.data ? (
              <>
                <Button
                  onClick={() => {
                    setDrawer(false);
                    navigate("/login");
                  }}
                  sx={{
                    textTransform: "none",
                    fontWeight: 700,
                    justifyContent: "flex-start",
                    color: "#757686",
                  }}
                >
                  Login
                </Button>
                <Button
                  onClick={() => {
                    setDrawer(false);
                    navigate("/register");
                  }}
                  sx={{
                    textTransform: "none",
                    fontWeight: 700,
                    justifyContent: "flex-start",
                    color: "#757686",
                  }}
                >
                  Register
                </Button>
              </>
            ) : (
              <Button
                onClick={() => {
                  logout();
                  setDrawer(false);
                }}
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  justifyContent: "flex-start",
                  color: "#757686",
                }}
              >
                Logout
              </Button>
            )}
          </Box>
        ) : !user?.data ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 0px",
              gap: "8px",
            }}
          >
            {/* /////////// goal stream button  */}
            <Button
              onClick={() => {
                navigate("/");
              }}
              sx={location == "" ? { color: "#d93349" } : { color: "#757686" }}
              className="appBar-btn"
            >
              {goalsIcon(location == "" ? true : false, {
                height: "20px",
                width: "20px",
              })}
              Goal Stream
            </Button>

            {/* //////////////////// add goal button  */}
            <Button
              onClick={() => {
                 if(loggedUser.device_id){
        // navigate("/login");
        // return ;
        setOpenGuestRistModal(true);
        return ;
      }
                // navigate("/login");
                setAnchorElNav(null);
              }}
              sx={{ color: "#757686" }}
            >
              <Box
                className="Add-icon-wrapper"
                sx={{ height: "55px", width: "55px" }}
              >
                <Box className="Add-icon">+</Box>
              </Box>
            </Button>
            {/* //////////////////// leaderboard button  */}
            <Button
              onClick={() => {
                navigate("/leaderboards");
              }}
              sx={
                location == "leaderboards"
                  ? { color: "#d93349" }
                  : { color: "#757686" }
              }
              className="appBar-btn"
            >
              {leaderboardIcon(location == "leaderboards" ? true : false, {
                height: "20px",
                width: "20px",
              })}
              Leaderboards
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 16px",
              gap: "8px",
            }}
          >
            {renderSectionSwitchButton({ fullWidth: true, size: "small" })}
            {/* /////////// goal stream button  */}
            <Button
              onClick={() => {
                navigate("/");
              }}
              sx={location == "" ? { color: "#d93349" } : { color: "#757686" }}
              className="appBar-btn"
            >
              {goalsIcon(location == "" ? true : false, {
                height: "20px",
                width: "20px",
              })}
              Goal Stream
            </Button>

            {/* //////////////////// leaderboard button  */}
            <Button
              onClick={() => {
                navigate("/leaderboards");
              }}
              sx={
                location == "leaderboards"
                  ? { color: "#d93349" }
                  : { color: "#757686" }
              }
              className="appBar-btn"
            >
              {leaderboardIcon(location == "leaderboards" ? true : false, {
                height: "20px",
                width: "20px",
              })}
              Leaderboards
            </Button>

            {/* //////////////////// add goal button  */}
            <Button
              onClick={() => {
                navigate("/addGoal");
                setAnchorElNav(null);
              }}
              sx={{ color: "#757686" }}
            >
              <Box
                className="Add-icon-wrapper"
                sx={{ height: "55px", width: "55px" }}
              >
                <Box className="Add-icon">+</Box>
              </Box>
            </Button>

            {/* //////////////////////////// my Account button  */}
            <Button
              onClick={() => {
                navigate("/myaccount");
              }}
              sx={
                location == "myaccount"
                  ? { color: "#d93349" }
                  : { color: "#757686" }
              }
              className="appBar-btn"
            >
              {myAccountIcon(location == "myaccount" ? true : false, {
                height: "20px",
                width: "20px",
              })}
              My Account
            </Button>

            {/* /////////////////////////////////// settings button  */}
            <Button
              onClick={() => {
                navigate("/settings/edit-profile");
              }}
              sx={
                location == "settings"
                  ? { color: "#d93349" }
                  : { color: "#757686" }
              }
              className="appBar-btn"
            >
              {settingsIcon(location == "settings" ? true : false, {
                height: "20px",
                width: "20px",
              })}
              Settings
            </Button>

            {/* /////////////////// user setting logout  */}
            <Tooltip title="Account">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  alt="Remy Sharp"
                  src={user.data?.profile_img ? user.data.profile_img : userD}
                  sx={{ width: 45, height: 45 }}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar-drawer"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem
                  key={setting}
                  onClick={() => {
                    logout();
                    setAnchorElUser(null);
                  }}
                >
                  <Typography sx={{ textAlign: "center" }}>
                    {setting}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        )}
      </Drawer>


          <GuestUserRistModal open={openGuestRistModal} setOpen={setOpenGuestRistModal} />
    </>
  );
}
